import { useTranslation } from 'react-i18next'

import { Paper } from 'shared/ui/paper'

import { InfoAboutTripRow } from './components/info-about-trip-row'
import s from './styles.module.scss'

interface Props {
  direction?: string
  company?: string
  transportType?: string
  transportNumber?: string
  route_desc?: string
}

export const InfoAboutTrip = ({
  company,
  direction,
  route_desc,
  transportType,
  transportNumber,
}: Props) => {
  const { t } = useTranslation()

  return (
    <Paper padding={[16]}>
      <div className={s.infoWrapper}>
        <p className="bold-17">{t('beket_content.info_about_ride')}</p>

        {direction && (
          <InfoAboutTripRow
            label={t('beket_content.route')}
            value={direction}
          />
        )}

        {company && (
          <InfoAboutTripRow
            label={t('beket_content.carrier')}
            value={company}
          />
        )}

        {transportType && (
          <InfoAboutTripRow
            label={t('beket_content.type_transport')}
            value={transportType}
          />
        )}

        {transportNumber && (
          <InfoAboutTripRow
            label={t('beket_content.number_transport')}
            value={transportNumber}
          />
        )}

        {route_desc && (
          <InfoAboutTripRow
            label={t('beket_content.more_info')}
            value={route_desc}
          />
        )}
      </div>
    </Paper>
  )
}
